/**
 * 是否嵌套在iframe框架中
 */
export function inFrame() {
    return window.top !== window.self;
}
/**
 * 是否浏览器环境
 */
export const isBrowser = typeof window !== 'undefined' && typeof window.window !== 'undefined';
